const IconX = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width='24'
    height='24'
    fill='none'
    strokeWidth='1.5'
    viewBox='0 0 24 24'
    stroke='currentColor'
    strokeLinecap='round'
    strokeLinejoin='round'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <line x1='18' y1='6' x2='6' y2='18' />
    <line x1='6' y1='6' x2='18' y2='18' />
  </svg>
);

export default IconX;
